import React from 'react';
import { StyleSheet, Text, TouchableOpacity } from './rn';
import ProfileSection from './ProfileSection';
import { useTheme } from '../theme/ThemeContext';
import { profilePalette } from '../theme/profileSection';
import { fontSize } from '../theme';

type Props = {
  label: string;
  onPress: () => void;
  /** Satırın kimliği; bölüm `${testID}-section` adını alır. */
  testID: string;
  /**
   * Geri alınamayan eylem kırmızı; onu geri alan eylem (Engeli kaldır) aynı
   * satırda nötr renk — onarıcı bir eylem yıkıcı gibi görünmemeli (D-305).
   */
  tone?: 'danger' | 'neutral';
  disabled?: boolean;
};

// 7.6 / D-668 — geri alınamayan eylemler tek biçimde: kendi bölümünde, sola
// yaslı kırmızı bir satır. Çıkış böyleydi (D-656); Engelle çerçeveli bir
// düğmeydi, rezervasyondaki "İptal et" ortalanmış kırmızı yazıydı. Batuhan:
// "Uygundur".
export default function SectionActionRow({ label, onPress, testID, tone = 'danger', disabled }: Props) {
  const colors = useTheme();
  const color = tone === 'danger' ? profilePalette(colors).danger : colors.black;
  return (
    <ProfileSection testID={`${testID}-section`}>
      <TouchableOpacity
        testID={testID}
        accessibilityRole="button"
        accessibilityState={{ disabled: !!disabled }}
        disabled={disabled}
        onPress={onPress}
        style={[styles.row, disabled && styles.disabled]}>
        <Text style={[styles.label, { color }]}>{label}</Text>
      </TouchableOpacity>
    </ProfileSection>
  );
}

const styles = StyleSheet.create({
  // Ayarlar'daki satırla aynı ölçü: en az 48 yükseklik, 12 dikey boşluk.
  row: { flexDirection: 'row', alignItems: 'center', paddingVertical: 12, minHeight: 48 },
  label: { flex: 1, minWidth: 0, fontSize: fontSize.md, fontWeight: '600' },
  disabled: { opacity: 0.5 },
});
